import { Theme, Typography, useTheme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React, { FC, useCallback } from 'react';
import { CategoryRiskNames } from 'common-types';
import { navigateToIssues } from '../../../common/routing/app-navigator';
import Hover from '../../../elements/Hover/Hover';
import { AppCategory } from '../../applications-types';

const ViolationTooltip: FC<
  React.PropsWithChildren<{
    category: AppCategory;
    appName: string;
  }>
> = ({ category, appName }) => {
  const { severities, total, categoryName } = category;
  const theme = useTheme();
  const { classes } = useStyles();
  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLDivElement>) => {
      event.preventDefault();
      event.stopPropagation();
      const { severity } = event.currentTarget.dataset;
      navigateToIssues({
        categories: [categoryName],
        criticality: [severity || ''],
        apps: [appName],
      });
    },
    [appName, categoryName],
  );

  return (
    <div className={classes.container}>
      <Typography variant='body1' color='text.primary'>
        Category Issues: {total}
      </Typography>
      {Object.keys(CategoryRiskNames).map(key => (
        <Hover key={key}>
          <div
            className={classes.severity}
            data-severity={CategoryRiskNames[key]}
            onClick={handleClick}>
            <span
              style={{
                backgroundColor: theme.palette.categoryRiskColor[key],
              }}
              className='legendIcon'
            />
            <Typography variant='body2' color='text.primary'>
              {severities[key]} {CategoryRiskNames[key]}
            </Typography>
          </div>
        </Hover>
      ))}
    </div>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    padding: theme.spacing(1, 0),
    display: 'flex',
    flexDirection: 'column',
  },
  severity: {
    alignItems: 'center',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
    padding: theme.spacing(0.5, 0.5),
    '& > .legendIcon': {
      height: 8,
      width: 8,
      borderRadius: '50%',
      display: 'inline-block',
      margin: theme.spacing(0, 1),
    },
  },
}));

export default ViolationTooltip;
